import {SxProps} from '@mui/material';
import {COMMON_STYLES} from '../../constants/styles';

export const STYLES = {
  ...COMMON_STYLES,
  mapContainer: {
    px: '46px',
  },
} as const satisfies SxProps;
